module.exports = __webpack_public_path__ + "static/kismet@fiferries.02438b94.jpg";